import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import axios from "axios";
import { Trophy, X, Sparkles, PartyPopper } from "lucide-react";

const API = window.location.origin;

const GiveawayWinnerBanner = () => {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [wins, setWins] = useState([]);

  useEffect(() => {
    if (!token) return;
    const fetchWins = async () => {
      try {
        const { data } = await axios.get(`${API}/api/giveaways/my-wins`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setWins(Array.isArray(data) ? data : []);
      } catch {}
    };
    fetchWins();
  }, [token]);

  const acknowledge = async (giveawayId) => {
    try {
      await axios.post(
        `${API}/api/giveaways/my-wins/${giveawayId}/acknowledge`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setWins((prev) => prev.filter((w) => w.giveaway_id !== giveawayId));
    } catch {}
  };

  if (!wins.length) return null;

  const win = wins[0];

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/85 backdrop-blur-md p-4"
      data-testid="giveaway-winner-modal"
    >
      <div
        className="relative max-w-sm w-full rounded-2xl border overflow-hidden text-center"
        style={{
          background: "linear-gradient(180deg, #1a1040 0%, #0f1529 100%)",
          borderColor: "rgba(245,158,11,0.3)",
          boxShadow: "0 0 60px rgba(245,158,11,0.15)",
        }}
      >
        {/* Confetti-like top accent */}
        <div
          className="h-1.5 w-full"
          style={{
            background:
              "linear-gradient(90deg, #f59e0b, #ef4444, #8b5cf6, #3b82f6, #10b981, #f59e0b)",
          }}
        />

        <div className="p-6 pt-8">
          {/* Trophy icon */}
          <div className="relative inline-flex items-center justify-center mb-4">
            <div
              className="w-20 h-20 rounded-full flex items-center justify-center"
              style={{
                background:
                  "radial-gradient(circle, rgba(245,158,11,0.2) 0%, transparent 70%)",
              }}
            >
              <Trophy
                className="w-12 h-12 text-amber-400 drop-shadow-[0_0_12px_rgba(245,158,11,0.6)]"
              />
            </div>
            <Sparkles className="absolute -top-1 -right-1 w-5 h-5 text-amber-300 animate-pulse" />
            <PartyPopper className="absolute -top-1 -left-1 w-5 h-5 text-purple-400 animate-pulse" />
          </div>

          <h2 className="text-2xl font-black text-white mb-1">
            Congratulations!
          </h2>
          <p className="text-amber-400 font-bold text-lg mb-3">
            You Won!
          </p>

          <div
            className="rounded-xl p-4 mb-4"
            style={{
              background: "rgba(245,158,11,0.08)",
              border: "1px solid rgba(245,158,11,0.2)",
            }}
          >
            <p className="text-sm font-bold text-white mb-1">{win.title}</p>
            {win.prize && (
              <p className="text-amber-400 font-semibold text-base">
                {win.prize}
              </p>
            )}
          </div>

          <p className="text-xs text-zinc-400 mb-5">
            You've been selected as the winner of this giveaway. Check your
            account or contact support for prize details.
          </p>

          <button
            onClick={() => acknowledge(win.giveaway_id)}
            className="w-full py-3 rounded-xl font-bold text-black text-sm transition-all hover:scale-[1.02]"
            style={{
              background: "linear-gradient(135deg, #f59e0b, #d97706)",
              boxShadow: "0 0 20px rgba(245,158,11,0.3)",
            }}
            data-testid="acknowledge-win-btn"
          >
            Awesome! Claim My Prize
          </button>
        </div>
      </div>
    </div>
  );
};

export default GiveawayWinnerBanner;
